import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, apiErrorMessage } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useI18n } from "../lib/i18n";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { t } = useI18n();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const token = params.get("token") || "";

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { toast.error("Password must be at least 8 characters"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset — you can log in now");
      nav("/login");
    } catch (err) {
      toast.error(apiErrorMessage(err, "Reset failed"));
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16 lg:py-24">
      <div className="font-mono text-[11px] uppercase tracking-widest text-[#2DD4A7] mb-3">Password reset</div>
      <h1 className="font-display text-4xl font-black tracking-tighter mb-8">Choose a new password</h1>
      {!token ? (
        <div className="border border-[#2DD4A7]/40 bg-[#2DD4A7]/10 p-4 text-sm text-[#2DD4A7]" data-testid="reset-missing-token">Missing token.</div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
          <div>
            <Label className="text-xs uppercase tracking-widest text-[#8B97AE]">New password</Label>
            <Input data-testid="reset-password" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-none bg-transparent border-white/20 h-12 mt-2 focus:ring-2 focus:ring-white" />
          </div>
          <Button data-testid="reset-submit" type="submit" disabled={busy} className="w-full rounded-none bg-[#2DD4A7] text-[#04150F] hover:bg-[#F5B841] hover:text-[#04150F] h-12 font-semibold transition-colors">
            {busy ? t("common.loading") : "Reset password"}
          </Button>
          <div className="text-xs text-[#8B97AE]">
            <Link to="/login" className="underline hover:text-white">Back to login</Link>
          </div>
        </form>
      )}
    </div>
  );
}
